<div class="o-media c-challenge-contestant">
    <div class="o-media__body c-challenge-contestant__body">
        <div>
            <h3 class="c-challenge-contestant__title">
                <a [locationHref]="getContestantLink(contestant)">
                    {{ "challenge-contestant:prove-skill" | translate: {
                        name: contestant.user?.nickname || contestant.team?.name
                    } }}
                </a>

                <a
                    href="https://play.eslgaming.com/premium"
                    title="ESL Premium"
                    *ngIf="contestant.user?.premium || contestant.team?.premium">
                    <img
                        src="https://cdn.eslgaming.com/play/eslstatic/skins/v2008_base/content/16_premium.gif"
                        title="ESL Premium"
                    >
                </a>

                <a
                    href="https://play.eslgaming.com/playercard_portal"
                    title="ESL Trusted 1/2/3/Pro"
                    *ngIf="contestant.user?.trustLevel > 0 || contestant.team?.trustLevel > 0">
                    <img
                        src="https://cdn.eslgaming.com/play/eslstatic/skins/v2008_base/content/16_trusted.gif"
                        title="ESL Trusted 1/2/3/Pro"
                    >
                </a>
            </h3>

            <div class="c-challenge-contestant__sub-title">
                {{ "challenge-contestant:stats" | translate: {
                    wins: contestant.stats.wins,
                    losses: contestant.stats.losses
                } }}
            </div>
        </div>

        <p class="c-challenge-contestant__description" [innerHtml]="description"></p>
        <div 
        class="ranking__challenge-button ranking__challenge-button--fit-content"
        [ngClass]="{
            'ranking__challenge-button--is-disabled': 
                league.state === 'finished' || 
                !league.challenge.enabled ||
                contestant.user.isBarred || 
                !(isLoggedIn | async) ||
                !(userEntry | async).length > 0 ||
                league.maxOpenMatches <= contestant.numOpenMatches 
        }"
        [attr.title]="
            league.challenge.enabled ?
                (isLoggedIn | async) ? 
                    (userEntry | async).length > 0 ? 
                        ('challenge-contestant:challenge' | translate) 
                    : ('challenge-contestant:signup-to-challenge' | translate) 
                : ('challenge-contestant:login-to-challenge' | translate )
            : ('challenge-contestant:disabled' | translate )
        "
        *ngIf="contestant.user">
                <a
                    href="{{ league.url }}matchsetup/challenge/?contestantId={{ contestant.user.id }}"
                    class="ranking__challenge-button__link no-decoration">
                    <span class="ranking__challenge-button__text" *ngIf="!contestant.user.isBarred">
                        {{ "challenge-contestant:challenge" | translate }}
                    </span>
        
                    <span class="ranking__challenge-button__challenges" *ngIf="!contestant.user.isBarred">
                        {{ contestant.numOpenMatches }}/{{ league.maxOpenMatches }}
                    </span>

                    <span class="ranking__challenge-button__text" *ngIf="contestant.user.isBarred">
                        {{ "league-rankings:barred" | translate }}
                    </span>

                    <span class="ranking__challenge-button__challenges" *ngIf="contestant.user.isBarred">
                        <svg viewBox="0 0 177.055 177.055" class="ranking__challenge-button__barred"><use xlink:href="/profiles/eslgaming_play/themes/eslgaming/eslgaming_play_base/dist/images/ranking/ladder.svg#icon-barred"></use></svg>
                    </span>
                </a>
                
        </div>

        <div  
            class="ranking__challenge-button ranking__challenge-button--fit-content"
            [ngClass]="{
                'ranking__challenge-button--is-disabled': 
                    league.state === 'finished' || 
                    !league.challenge.enabled ||
                    contestant.team.isBarred || 
                    !(isLoggedIn | async) ||
                    !(userEntry | async).length > 0 ||
                    league.maxOpenMatches <= contestant.numOpenMatches 
            }"
            [attr.title]="
                league.challenge.enabled ?
                    (isLoggedIn | async) ? 
                        (userEntry | async).length > 0 ? 
                            ('challenge-contestant:challenge' | translate) 
                        : ('challenge-contestant:signup-to-challenge' | translate) 
                    : ('challenge-contestant:login-to-challenge' | translate )
                : ('challenge-contestant:disabled' | translate )
            "
            *ngIf="contestant.team">
                <a
                    href="{{ league.url }}matchsetup/challenge/?contestantId={{ contestant.team.id }}"
                    class="ranking__challenge-button__link no-decoration">
                    <span class="ranking__challenge-button__text" *ngIf="!contestant.team.isBarred">
                        {{ "challenge-contestant:challenge" | translate }}
                    </span>
        
                    <span class="ranking__challenge-button__challenges" *ngIf="!contestant.team.isBarred">
                        {{ contestant.numOpenMatches }}/{{ league.maxOpenMatches }}
                    </span>

                    <span class="ranking__challenge-button__text" *ngIf="contestant.team.isBarred">
                        {{ "league-rankings:barred" | translate }}
                    </span>

                    <span class="ranking__challenge-button__challenges" *ngIf="contestant.team.isBarred">
                        <svg viewBox="0 0 177.055 177.055" class="ranking__challenge-button__barred"><use xlink:href="/profiles/eslgaming_play/themes/eslgaming/eslgaming_play_base/dist/images/ranking/ladder.svg#icon-barred"></use></svg>
                    </span>
                </a>
        </div>

    </div>

    <img class="o-media__figure c-challenge-contestant__image" *ngIf="contestant.user" [src]="contestant.user.photo" />
    <img class="o-media__figure c-challenge-contestant__image" *ngIf="contestant.team" [src]="contestant.team.logo" />
</div>
